export const formFieldConstants = {
    selectFieldOptionsCode: 'code',
    selectFieldOptionsLabel: 'label',
    itemList: 'itemList'
}
